import {api} from "../../../../api/API";

// adoptHardwareElevation links a hardware elevation to an opening (or quote opening). When its hinge
// layout needs the opening moved out of its hardware heading, it asks first. Resolves false when the
// user declines; nothing is linked then.
export async function adoptHardwareElevation(confirm: (message: string) => Promise<boolean>, props: {
    project: number;
    opening?: number;
    quoteOpening?: number;
    hardware: number;
}): Promise<boolean> {
    const res = await api.elevationTool.adoptHardware(props);
    const split = res.hingeGroupSplit;
    if(!split) return true;

    const staying = split.staying ?? [];
    const ok = await confirm(`The hinge layout of this hardware elevation is different from hardware heading ${split.group}. `
        + `Linking it moves ${(split.moving ?? []).join(", ")} into a new hardware heading`
        + (staying.length > 0 ? `, and ${staying.join(", ")} keep${staying.length === 1 ? "s" : ""} ${split.group}` : "")
        + `. Continue?`);
    if(!ok) return false;

    await api.elevationTool.adoptHardware({...props, confirm: true});
    return true;
}
